/**
 * This module provides functions in relation to calling API routes on the backend server and processing the incoming
 * responses. The functions in this module refer to the API endpoint ApiEndPoints.WMT.
 * @module
 */
import { ApiEndPoints, HttpMethods } from "../base/Settings";
import type { FetchRequest, UUID } from "../base/ui_general/GeneralInterfaces";


/**
 * Creates a FetchRequest object for fetching the Waterfall Master Table (WMT) from the server.
 * @param transaction_id The UUID of the transaction to query WMT for.
 * @param scenario_nr The scenario number to fetch the WMT for.
 * @returns A FetchRequest object containing the generated fetch request.
 */
export function getRequest_get_wmt(transaction_id: UUID, scenario_nr: number): FetchRequest {
    return {
        api_endpoint: ApiEndPoints.WMT,
        method: HttpMethods.GET,
        query_parameters: {
            transaction_id: transaction_id,
            scenario_nr: scenario_nr,
        },
    };
}